import { Outlet, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAppStore } from "../store";
import { StorageBox } from "../core/storage";
import DataProvider from "../services";

const AuthRoutes = () => {
  const { user, setUser, setToken, rehydrated } = useAppStore();
  const navigate = useNavigate();
  // Protected pages (and their own data-fetch effects) no longer mount
  // until this resolves - previously <Outlet /> rendered unconditionally
  // while the redirect only fired inside a useEffect afterward, so a
  // previous session's data could flash on screen before the check landed.
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (!rehydrated) return;

    let cancelled = false;
    (async () => {
      // user/token are no longer persisted in the zustand store (see
      // store/index.ts) - StorageBox's encrypted token is the single
      // source of truth for whether a session exists at all.
      const storedToken = StorageBox.getToken();
      if (!storedToken) {
        if (!cancelled) {
          setChecked(true);
          navigate("/sign-in");
        }
        return;
      }

      if (!user) {
        // Fresh page load: a token exists but the in-memory profile
        // doesn't yet - fetch it before letting anything render.
        try {
          const { data } = await DataProvider.getProfile();
          if (cancelled) return;
          setUser({ ...data, timenow: new Date() });
          setToken({ token: storedToken });
        } catch {
          if (cancelled) return;
          StorageBox.clearStorage();
          setChecked(true);
          navigate("/sign-in");
          return;
        }
      }

      if (!cancelled) setChecked(true);
    })();

    return () => {
      cancelled = true;
    };
  }, [rehydrated, user, navigate, setToken, setUser]);

  if (!checked) return null;
  return <Outlet />;
};

export default AuthRoutes;
